import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { markPrerenderChunks } from './lib/prerenderChunks';
import { captureReferral } from './utils/referral';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './components/UserContext';

markPrerenderChunks();

// First-touch źródło wejścia - zapisujemy przed renderem, żeby nie zgubić
// parametrów UTM/referrera. Bezpieczne poza przeglądarką (guard + try/catch w środku).
if (typeof window !== 'undefined') {
  captureReferral();
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const tree = (
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <App />
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>
);

/* Montujemy dopiero po pierwszym malowaniu.
 *
 * `createRoot` czyści kontener, więc React kasował prerenderowaną treść, ZANIM
 * przeglądarka zdążyła ją namalować (bundle jest `defer`, czyli wykonuje się
 * przed pierwszym malowaniem). Efekt: FCP i LCP strony głównej dopiero po
 * wykonaniu bundle'a - 416 ms zamiast ~180 ms, w których gotowy HTML już czeka.
 *
 * `hydrateRoot` NIE jest tu rozwiązaniem: prerender zapisuje DOM zrzucony po
 * wykonaniu efektów (`chrome --dump-dom`), a hydratacja porównuje go z PIERWSZYM
 * renderem, sprzed efektów - sprawdzone na bliźniaczym projekcie, hydratacja
 * wywala się na każdej trasie (React #425/#418/#423) i tak czy siak przebudowuje
 * całe drzewo.
 *
 * requestAnimationFrame + setTimeout(0) = "po najbliższym malowaniu". Cena to
 * jedna klatka opóźnienia interaktywności; zysk to pełne FCP/LCP na treści,
 * która i tak jest już w HTML-u.
 */
const mount = () => root.render(tree);

if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
  window.requestAnimationFrame(() => window.setTimeout(mount, 0));
} else {
  mount();
}

reportWebVitals();
